import { render, staticRenderFns } from "./UpdateAgreePrivacyPopup.vue?vue&type=template&id=4f0c3de1&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports